import React from 'react';
import {Route, Switch} from 'react-router-dom';
import index from '../index.js'
import complete from '../complete.js';
import comprehend from '../comprehend.js';
import createEvent from '../createEvent.js';
import editEvent from '../editEvent.js';
import chartEvent from '../chart.js';

const RouterApp = () => (
    <Switch>
        <Route exact name="homepage" path="/" component={index} />
        <Route exact name="complete" path="/event" component={complete} />
        <Route name="createEvent" path="/createEvent" component={createEvent} />
        <Route name="eventDetails" path="/editEvent/:eventId" component={editEvent} />
        <Route name="comprehend" path="/comprehendEvent" component={comprehend} />
        <Route name="chartEvent" path="/chartEvent/:slug" component={chartEvent} />
    </Switch>

)

export default RouterApp;


// WEBPACK FOOTER //
// ./src/components/pages/routerApp/routerApp.js